var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen bg-blanc-casse"},[_c('toast-bar'),(_vm.loading)?_c('loader',{attrs:{"loading":_vm.loading}}):_vm._e(),_c(_vm.layout,{tag:"component"},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }